export default __webpack_public_path__ + "static/client_back-4dcae451948923d65c57cc37c75bebdd.webp";